import { useRedux } from "hooks";
import React, { useEffect, useState, useRef } from "react";
import {
    Form,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Label,
    Input,
    Spinner,
} from "reactstrap";
import { createSelector } from "reselect";
import Loader from "./Loader";
import { generateGroupInviteCode2Async, getGroupInviteCode2Async } from "../api/chats";
import { Exception } from "sass";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { APIClient } from "api/apiCore";
import AppSimpleBar from "./AppSimpleBar";
import { debounce } from "lodash";
import { Utils } from "helpers/utils";
import { ChatContact2, swapChatToTop as sl2_swapChatToTop } from "../redux/chats/slice";
import * as url from "../api/urls"
import { UserTypes } from "api";


interface CreateChatRoomModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSelectChat: (id: number | string) => void;
    groupType: UserTypes;
}

const CreateChatRoomModal = ({
    isOpen,
    onClose,
    onSelectChat,
    groupType
}: CreateChatRoomModalProps) => {

    const { dispatch, useAppSelector } = useRedux();
    const storeData = createSelector(
        (state) => state.Profile2,
        (state) => ({
            // groupInviteCode: state.groupInviteCode,
            // groupInviteOn: state.groupInviteOn,
            profile2: state
        })
    );
    const { /*groupInviteCode, groupInviteOn,*/ profile2 } = useAppSelector(storeData);
    // console.log('profile2:', profile2);
    const [isGenCode, setIsGenCode] = useState<boolean>(false);
    const [errMessage, _a1] = useState<string>("");
    const [errClass, _a2] = useState<string>("danger");
    const [groupInviteCode, setGroupInviteCode] = useState('');
    const [groupInvoiceExpire, setGroupInvoiceExpire] = useState<any>(null);
    // console.log('profile2:', profile2);

    const groupTypeName = groupType == UserTypes.GroupSupplier ? "Supplier" : "ลูกค้า";

    useEffect(() => {
        // console.log('profile2-2:', profile2);
        const fetch = async () => {
            await getGroupInviteCode2Async(-1)
                .then(response => {
                    // console.log('getGroupInviteCode2Async:', response);
                    setGroupInviteCode(response.groupInviteCode);
                    setGroupInvoiceExpire(response.groupInviteExpired);
                })
                .catch(err => console.error(err));
        }
        fetch();
    }, []);

    const fnSetMsg = (err: boolean, msg: string) => {
        _a1(msg);
        _a2(err ? "danger" : "success");
    }

    const onCopyClick = async () => {
        if (groupInviteCode) {
            await navigator.clipboard.writeText(groupInviteCode);
            fnSetMsg(false, "คัดลอกลงคลิปบอร์ดแล้ว");
        } else {
            fnSetMsg(true, "ยังไม่มีรหัส, กรุณาสร้างรหัสก่อน");
        }
    }

    const fnGenCodeClick = async () => {
        fnSetMsg(false, "กำลังประมวลผล");
        setIsGenCode(true);
        generateGroupInviteCode2Async(-1)
            .then(result => {
                // console.log('generateGroupInviteCode2Async:', result);
                if (result.success) {
                    fnSetMsg(false, "ประมวลผลสำเร็จ");
                    setGroupInviteCode(result.data.groupInviteCode);
                    setGroupInvoiceExpire(result.data.groupInviteExpired);
                } else {
                    fnSetMsg(true, result.message);
                }
                setIsGenCode(false);
            })
            .catch(error => {
                fnSetMsg(true, (error as Exception).message);
                setIsGenCode(false);
                // console.log(error);
            });
    }

    type Option = {
        label: string;
        value: string;
    };

    const [options, setOptions] = useState<Option[]>([]); // Store fetched options
    const [isLoading, setIsLoading] = useState(false); // Show loading spinner
    const [groupFindResult, setGroupFindResult] = useState<any[]>([]);


    const fetchOptions = async (inputValue: string) => {
        try {
            // Simulate an API call to fetch data from the database
            setIsLoading(true);
            // const response = await fetch(`/find-chat-room?query=${inputValue}`);
            const api = new APIClient
            const response = await api.fnPostForm(`/find-chat-room`, { filters: inputValue });
            setGroupFindResult(response);
            // console.log('response:', response);
            // const data = await response.json();

            // Transform data to match React-Select's format
            // const transformedOptions = data.map((item: any) => ({
            //     label: item.fullName, // Replace with the database field name
            //     value: item.userId,   // Replace with the unique field
            // }));

            // setOptions(transformedOptions);
            setIsLoading(false);
        } catch (e) {
            console.error(e);
        }
    };

    const debounceFetchOptions = debounce((filters) => {
        fetchOptions(filters);
    }, 800); // Adjust the debounce time as necessary        

    const handleInputChange = (inputValue: string) => {
        debounceFetchOptions(inputValue);
        // fetchOptions(inputValue);
    };

    const txtChatRoomName = useRef<any>(null);

    const handleGroupNameClick = (value: string) => {
        if (txtChatRoomName.current) txtChatRoomName.current.value = value;
        setGroupFindResult([]);
    }

    const onCreateNewChatRoom = async () => {
        try {
            const chatRoomName = txtChatRoomName.current.value;
            if (!chatRoomName) {
                alert('ยังไม่ได้ระบุชื่อห้อง');
                return;
            }
            Utils.SweetConfirm(`ยืนยันการสร้างห้องแชท<br/><span class="text-red">${groupTypeName}</span> : <span class="text-red">${chatRoomName}</span><br/>ใช่หรือไม่`)
                .then((result) => {
                    if (result.isConfirmed) {
                        const parm = {
                            companyName: txtChatRoomName.current.value,
                            groupInviteCode: groupInviteCode,
                            groupInviceExpire: Utils.ToLocalDateString(groupInvoiceExpire),
                            groupType: groupType
                        };
                        // console.log('parm:', parm);
                        const api = new APIClient();
                        api.fnPostForm(url.CREATE_NEW_CHAT_ROOM, parm)
                            .then((result) => {
                                // console.log('result:', result);

                                const newMsg: ChatContact2 = {
                                    userId: result.conversationId,
                                    unreadCount: result.unreadCount,
                                    lastChatText: result.newTextShow,
                                    lastChatTime: result.lastChatTime,
                                    abbrName: result.senderAbbrName,
                                    bgColor: result.senderForeColor,
                                    foreColor: result.senderBgColor,
                                    isFavorite: false,
                                    fullName: result.senderName,
                                    profileImage: result.senderPictureUrl
                                };
                                dispatch(sl2_swapChatToTop({ groupType: groupType, newMsg: newMsg }));
                                onClose();
                                onSelectChat(result.conversationId);
                            })
                            .catch((error) => {
                                const msg = error?.response?.data?.replaceAll('Internal server error:', '') ?? (error as any).message;
                                console.error(error);
                                // console.error(error.response.data);
                                alert(msg);
                            });
                    }
                })
                .catch((error) => {
                    console.error(error);
                    alert((error as any).message);
                });
        } catch (e) {
            console.error(e);
            alert((e as any).message);
        }
    }
    // const [selectedDate, setSelectedDate] = useState<any>(null);

    return (
        <Modal isOpen={isOpen} toggle={onClose} tabIndex={-1} centered scrollable >
            <ModalHeader className="bg-primary" toggle={onClose}>
                <div className="modal-title-custom text-white font-size-16 ">
                    สร้างห้องแชท <span className="text-warning">{groupTypeName}</span> ใหม่
                </div>
            </ModalHeader>
            <ModalBody className="p-4">
                <Form>
                    <div className="row">
                        <div className="col text-center">
                            <span className="text-red">{errMessage || '\u00A0'}</span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            ชื่อห้องแชท
                            <input type="text" ref={txtChatRoomName} id="txtChatRoomName" className="form-control" onChange={(e: any) => handleInputChange(e.target.value)}></input>
                            {groupFindResult && groupFindResult.length > 0 && (
                                <div className="tag-name-container-div">
                                    <AppSimpleBar
                                        className={"tag-name-container " + Utils.GetCssSuffixTheme("tag-name-container")}
                                    // style={{
                                    //     top: dropdownPosition.top,
                                    //     left: dropdownPosition.left,
                                    //     maxHeight: tagNameDropDownHeight + 'px',
                                    //     minHeight: tagNameDropDownHeight + 'px',
                                    // }}
                                    >
                                        <ul style={{ /*listStyle: "none"/*, paddingLeft: "0px"*/ }}
                                        >
                                            {groupFindResult.map((name, index) => {
                                                return (
                                                    <>
                                                        {index == 0 && (<li className="text-secondary"><i>-- รายชื่อห้องที่มีในระบบแล้ว --</i></li>)}
                                                        <li
                                                            key={name.id}
                                                            // style={{
                                                            //     padding: '5px 10px',
                                                            //     minHeight: tagNameHeight + 'px',
                                                            //     maxHeight: tagNameHeight + 'px',
                                                            //     cursor: 'pointer',
                                                            //     // backgroundColor: '#f5f5f5',
                                                            //     // borderBottom: '1px solid #ddd',
                                                            // }}
                                                            onClick={() => handleGroupNameClick(name.fullName)}
                                                        >
                                                            {name.fullName}
                                                        </li>
                                                    </>
                                                )
                                            })}
                                        </ul>
                                    </AppSimpleBar>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            รหัสห้องแชท
                            <div className="input-group mb-3">
                                <input type="text" id="txtGroupInviteCode" className="form-control" value={groupInviteCode}></input>
                                <div className="input-group-append">
                                    <button className="btn btn-outline-secondary" type="button" onClick={fnGenCodeClick}>Gen</button>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            วันหมดอายุ
                            <DatePicker
                                selected={groupInvoiceExpire}
                                onChange={(date: any) => setGroupInvoiceExpire(date)}
                                dateFormat={"dd/MM/yyyy"} isClearable className="form-control" portalId="root-portal"></DatePicker>
                            {/* <input type="text" id="txtGroupInviteExpire" className="form-control"></input> */}
                        </div>
                    </div>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button type="button" color="secondary" className="btn" onClick={onClose} >
                    ปิด
                </Button>
                <Button
                    type="button"
                    color="primary"
                    // disabled={!valid}
                    onClick={() => onCreateNewChatRoom()}
                >
                    สร้างห้องแชท
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default CreateChatRoomModal;
